import { useContext, useMemo } from 'react';

import {
  UpdateUserCustomDataContext,
  UserAccountContext,
  UserAccountLoadingContext,
  UserCustomDataContext,
  UserCustomDataUpdatingContext,
} from './contexts';

export function useUserAccount() {
  return useContext(UserAccountContext);
}

export function useIsLoadingUserAccount() {
  return useContext(UserAccountLoadingContext);
}

export function useUserCustomData() {
  const userCustomData = useContext(UserCustomDataContext);
  return useMemo(() => userCustomData?.toJS(), [userCustomData]);
}

export function useIsUpdatingUserCustomData() {
  return useContext(UserCustomDataUpdatingContext);
}

export function useUpdateUserCustomData() {
  return useContext(UpdateUserCustomDataContext);
}

export function useIsLoggedIn() {
  return !!useUserAccount();
}

export function useIsFrontPorchUser() {
  const { channels } = useUserAccount() || {};
  return !channels?.length;
}

export function useIsChannelEntitled(channelId) {
  const { channels } = useUserAccount();
  return useMemo(() => channels?.includes(channelId), [channelId, channels]);
}
